export const FETCH_CONSOLE_COMMAND_LOG_LIST = 'consoleCommandLogs/FETCH_CONSOLE_COMMAND_LOG_LIST';
export const FETCH_CONSOLE_COMMAND_LOG_LIST_SUCCESS =
  'consoleCommandLogs/FETCH_CONSOLE_COMMAND_LOG_LIST_SUCCESS';
